import ComponentConfig from './component-config';

const ERROR_ELEMENT_PROPERTY = 'componentElement';
const NODE_COMPONENT_PROPERTY = '__dcComponent42';

export default class ComponentsFactory {
    static getInstance() {
        if (ComponentsFactory.instance === null) {
            ComponentsFactory.instance = new ComponentsFactory();
        }
        return ComponentsFactory.instance;
    }

    constructor() {
        if (ComponentsFactory.instance !== null) {
            return ComponentsFactory.instance;
        }

        this.registeredConfigs = [];
        this.instances = [];
    }

    define(id, className, selector) {
        const componentConfig = new ComponentConfig(id, className, selector);
        this.registeredConfigs.push(componentConfig);
    }

    defineWithCustomSelector(selector, className, id = null) {
        const componentConfig = new ComponentConfig(id, className, selector);
        this.registeredConfigs.push(componentConfig);
    }

    init(root = null) {
        this.registeredConfigs.forEach((config) => {
            try {
                // we are able to create the same component on the same node multiple times
                // and we don't want to change existing ones or add repetitive to this.instances
                const createdInstances = this._bootstrapConfig(config, root);
                const newInstances = createdInstances.reduce((result, instance) => {
                    if (this.instances.indexOf(instance) === -1) {
                        result.push(instance);
                    }
                    return result;
                }, []);

                if (newInstances.length > 0) {
                    this.instances = [...this.instances, ...newInstances];
                }
            } catch (error) {
                console.error(`Component ${config.className.name} with id "${config.id}" was not created due to error: ${error.message}`, error[ERROR_ELEMENT_PROPERTY]);
                console.error(error);
            }
        });
    }

    createComponents(root, id, className) {
        const config = new ComponentConfig(id, className);
        return this._bootstrapConfig(config, root);
    }

    createComponent(root, id, className) {
        const components = this.createComponents(root, id, className);
        return components.length > 0 ? components[0] : null;
    }

    destroy(root) {
        if (!root) {
            try {
                throw new Error('Components factory: You send invalid root node and have to fix you code');
            } catch (error) {
                console.log(error);
            }
            return;
        }

        this.instances = this.instances.filter((instance) => {
            if (instance.element === root || root.contains(instance.element)) {
                this._destroyComponent(instance);
                return false;
            }

            return true;
        });
    }

    _bootstrapConfig(componentConfig, root = null) {
        if (root === null) {
            root = document.body;
        }
        const className = componentConfig.className;
        let selector;

        if (componentConfig.selector) {
            selector = componentConfig.selector;
        } else if (componentConfig.id) {
            selector = `[${ComponentConfig.getComponentProperty()}="${componentConfig.id}"]`;
        } else {
            throw new Error('Id and Selector aren\'t provided');
        }

        const elements = [...root.querySelectorAll(selector)];
        const instances = [];

        if (root.matches(selector)) {
            elements.push(root);
        }

        elements.forEach((element) => {
            if (!element.components) {
                element.components = {};
            }

            if (element[NODE_COMPONENT_PROPERTY]) {
                instances.push(element[NODE_COMPONENT_PROPERTY]);
            } else {
                try {
                    const instance = new className(element, componentConfig.id);
                    element[NODE_COMPONENT_PROPERTY] = instance;
                    instances.push(instance);
                } catch (error) {
                    error[ERROR_ELEMENT_PROPERTY] = element;
                    throw error;
                }
            }
        });

        return instances;
    }

    _destroyComponent(component) {
        component.element[NODE_COMPONENT_PROPERTY] = null;
        component.destroy();
    }
}

ComponentsFactory.instance = null;
